// Vendor libraries
import { combineReducers } from '@ngrx/store';
// Utils / Constants
import { appStateSliceKey } from 'NewAngular/state/app-state/app-state.reducer';
import { savedItems } from 'NewAngular/features/components/saved-items/state/saved-items.reducer';
import { createReducerWithAppState } from 'NewAngular/state/app-state/utils';
import { SCATTER_PLOT_SYSTEM_DEFAULT_STATE, SCATTER_PLOT_APP_STATE_SLICE_KEY, } from 'ChartApp/ts/apps/scatter-plot/state/constants';
// NgRx reducers
import { axisExtremes } from 'ChartApp/ts/apps/scatter-plot/state/axis-extremes/axis-extremes.reducer';
import { calcInfo } from 'CalculationsApp/ts/state/calc-info.reducer';
import { chartId } from './chart-id/chart-id.reducer';
import { chartType } from './chart-type/chart-type.reducer';
import { dataFormat } from './data-format/data-format.reducer';
import { displayAllCurrencyCodes } from './chart-options/display-all-currency-codes.reducer';
import { displayAllDates } from './chart-options/display-all-dates.reducer';
import { displayAllNames } from './chart-options/display-all-names.reducer';
import { displayAllTickers } from './chart-options/display-all-tickers.reducer';
import { displayAllXYData } from './chart-options/display-all-x-y-data.reducer';
import { displayBestFitLine } from './chart-options/display-best-fit-line.reducer';
import { displayColorRange } from './chart-options/display-color-range.reducer';
import { displayLegend } from './chart-options/display-legend.reducer';
import { displayLegendOnChart } from './chart-options/display-legend-on-chart.reducer';
import { displayCurrencyCodeInLegend } from './chart-options/display-currency-code-in-legend.reducer';
import { displayXYDataInLegend } from './chart-options/display-x-y-data-in-legend.reducer';
import { endDate } from './end-date/end-date.reducer';
import { nameInLegend } from 'ChartApp/ts/apps/scatter-plot/state/chart-options/name-in-legend.reducer';
import { labelPlacements } from 'ChartApp/ts/apps/scatter-plot/state/label-placements/label-placements.reducer';
import { lookback } from 'ChartApp/ts/apps/scatter-plot/state/lookback/lookback.reducer';
import { note } from 'ChartApp/ts/apps/scatter-plot/state/presentation-options/note.reducer';
import { plotOptions } from './plot-options/plot-options.reducer';
import { plotType } from './plot-type/plot-type.reducer';
import { securities } from './securities/securities.reducer';
import { size } from 'ChartApp/ts/apps/scatter-plot/state/presentation-options/size.reducer';
import { startDate } from './start-date/start-date.reducer';
import { title } from 'ChartApp/ts/apps/scatter-plot/state/presentation-options/tite.reducer';
import { useCustomColors } from './chart-options/use-custom-colors.reducer';
import { xAxisMetric } from './x-axis-metric/x-axis-metric.reducer';
import { xAxisDate } from './x-axis-date/x-axis-date.reducer';
import { yAxisDate } from './y-axis-date/y-axis-date.reducer';
import { yAxisMetric } from './y-axis-metric/y-axis-metric.reducer';
import { securitiesInfo } from 'SecuritiesApp/ts/state/securities-info/securities-info.reducer';
import { performanceDisclosure } from 'ChartApp/ts/apps/scatter-plot/state/chart-options/performance-disclosure.reducer';
export const scatterPlot = combineReducers({
    // Shared Params
    chartId,
    chartType,
    axisExtremes,
    // Interactive Chart options
    displayAllTickers,
    displayAllXYData,
    displayBestFitLine,
    displayAllCurrencyCodes,
    displayAllDates,
    displayAllNames,
    displayLegend,
    displayCurrencyCodeInLegend,
    displayXYDataInLegend,
    // Presentation Chart Options
    displayLegendOnChart,
    // Presentation Options
    note,
    size,
    title,
    performanceDisclosure,
    // Other
    nameInLegend,
    labelPlacements,
    plotOptions,
    plotType,
    securities,
    // Color
    displayColorRange,
    useCustomColors,
    // Metrics
    xAxisMetric,
    yAxisMetric,
    // Point in time scatter plots only
    lookback,
    xAxisDate,
    yAxisDate,
    // Timeseries scatter plots only
    dataFormat,
    endDate,
    startDate,
});
const initialSystemState = {
    [SCATTER_PLOT_APP_STATE_SLICE_KEY]: SCATTER_PLOT_SYSTEM_DEFAULT_STATE,
};
const initialUserState = {
    [SCATTER_PLOT_APP_STATE_SLICE_KEY]: window.userProvidedAppState,
};
const reducers = combineReducers({
    appStateSliceKey,
    savedItems,
    scatterPlot,
    calcInfo,
    securitiesInfo,
});
export const rootReducer = createReducerWithAppState(reducers, initialSystemState, initialUserState);
